var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nested-block-pub',{attrs:{"value":{tag: 'div', blocks: _vm.$store.state.site.article.blocks},"global_style":_vm.global_style}})}
var staticRenderFns = []

export { render, staticRenderFns }